import {
	Container,
	Heading,
	Stack,
	TabContent,
	Tabs,
	TabsList,
} from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { Outlet } from "react-router"
import { generatePath } from "../../../../../router-utils"

export default function Layout() {
	return (
		<Stack gap="4">
			<Container>
				<Heading>Document Types</Heading>
			</Container>
			<Tabs layout="col" gap="6">
				<TabsList>
					<NavLink to={generatePath("/org/document/types")}>
						Document Types
					</NavLink>
					<NavLink to={generatePath("/org/document/groups")}>
						Document Groups
					</NavLink>
				</TabsList>
				<TabContent>
					<Outlet />
				</TabContent>
			</Tabs>
		</Stack>
	)
}
